import { render } from "./Notfound.vue?vue&type=template&id=633353c8&scoped=true"
const script = {}

import "./Notfound.vue?vue&type=style&index=0&id=633353c8&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633353c8"]])

export default __exports__